export { default } from './badge-golder-property'